// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-main {
  display: flex;
  padding: 12px 12px;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 auto;
  position: relative;
  z-index: 4;
}
.header-main .search-part {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: flex-start;
}
.header-main .search-part input {
  display: flex;
  padding: 8px 16px;
  border-radius: 30px;
  width: 60%;
  outline: 0;
  box-shadow: none;
  border: 1px solid #f4f4f4;
  font-size: 16px;
  line-height: 100%;
  color: #b0b0b0;
}
.header-main .search-part input:focus{
  border: 1px solid #ff6036;
}
.header-main .search-part input::placeholder {
  color: #b0b0b0;
  font-size: 16px;
}
.header-main .search-part .icon-search {
  color: #b0b0b0;
  margin-left: -35px;
}
.header-main .profile-part {
  display: flex;
  flex: 1 1;
  gap: 15px;
  justify-content: flex-end;
  align-items: center;
}
.header-main .profile-part .notification-block {
  display: flex;
  position: relative;
}
.header-main .profile-part .notification-block .noti-no {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  font-size: 10px;
  color: white;
  border-radius: 30px;
  background-color: #ff6036;
  position: absolute;
  top: -5px;
  right: -5px;
}
.header-main .profile-part .profile {
    display: flex;
    gap: 10px;
    align-items: center;
}
.header-main .profile-part .profile .btn-custom {
    background-color: transparent;
    border: none;
    color: black;
    font-size: 16px;
}
.dropdown-item{
  font-size: 14px !important;
}





/* Styles for the dropdowns */
.dropdowns {
  position: absolute;
  top: 100%; /* Position the dropdowns below the input */
  /* left: 300px; */
  width: 40%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  /* display: none; */
   /* Initially hide the dropdowns */
  z-index: 1; /* Ensure it's above other content */
}

/* Styles for the dropdowns list */
.dropdowns-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

/* Styles for the dropdowns list items */
.dropdowns-list li {
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

/* Highlight list item on hover */
.dropdowns-list li:hover {
  background-color: #f0f0f0;
}
.owl-carousel {
  z-index: 0 !important;
}
.appointment-card, .assign-doctor-card{
  z-index: 0 !important;
}

/* header.css */
@media (max-width: 767.98px) { /* Adjust this value based on your mobile breakpoint */
  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    max-height: 100vh;
    min-height: 100vh;
    overflow: scroll;
  }
}
.navbar-toggler {
  border: none;
  /* Optional: add a background color to the toggle button */
  background-color: #f8f9fa; /* Change as needed */
}
@media (max-width: 767.98px) {
  /* Adjust styles specifically for mobile screens here */
  .navbar {
    /* Any specific mobile styles */
  }

  .navbar-collapse {
    /* Mobile specific styles */
    max-height: 100vh;
    min-height: 100vh;
    overflow-y: auto; /* Allows scrolling within the navbar */
  }

  /* Adjust the padding for search input and other elements as needed */
  .search-part input {
    width: 100%;
    margin: 0.5rem 0;
  }
  .search-part{
    /* margin-left: 40px; */
    display: none !important;
  }

  .profile-part{
    justify-content: start !important;
    margin-left: 40px;
    margin-top: 2rem;
    margin-bottom: 12rem !important;
  }

  .navbar-collapse.show .sidebar-main {
    display: block;
    width: 100%;
    height: auto;
    /* Add any additional styling for mobile sidebar here */
  }

}


.navbar-collapse  .sidebar-main {
  display: none;
}



/* Notification Modal Started */

.notication-modal .modal-content
{
  padding: 0px 0px;
  background-color: #F9F9F9;
}

.notication-modal .modal-header
{
  padding: 20px 30px;
}
.notication-modal .modal-header .modal-title{
  padding-bottom: 0px;
}
.notication-modal .modal-body
{
  padding: 0px 15px;
}
.notication-modal .modal-dialog {
  max-width: 600px;
}
.notication-modal .modal-content{
  border-radius: 8px;
}
.notication-modal p {
  margin-bottom: 0px;
}
/* Notification Modal Ended */
`, "",{"version":3,"sources":["webpack://./src/assets/css/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;AACA;EACE,0BAA0B;AAC5B;;;;;;AAMA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS,EAAE,2CAA2C;EACtD,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;GAClB,iCAAiC;EAClC,UAAU,EAAE,oCAAoC;AAClD;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf,+BAA+B,sDAAsD;EACnF;;IAEE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;EACZ,0DAA0D;EAC1D,yBAAyB,EAAE,qBAAqB;AAClD;AACA;EACE,uDAAuD;EACvD;IACE,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB,EAAE,uCAAuC;EAC3D;;EAEA,qEAAqE;EACrE;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uDAAuD;EACzD;;AAEF;;;AAGA;EACE,aAAa;AACf;;;;AAIA,+BAA+B;;AAE/B;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA,6BAA6B","sourcesContent":[".header-main {\r\n  display: flex;\r\n  padding: 12px 12px;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex: 1 1 auto;\r\n  position: relative;\r\n  z-index: 4;\r\n}\r\n.header-main .search-part {\r\n  display: flex;\r\n  flex: 1;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.header-main .search-part input {\r\n  display: flex;\r\n  padding: 8px 16px;\r\n  border-radius: 30px;\r\n  width: 60%;\r\n  outline: 0;\r\n  box-shadow: none;\r\n  border: 1px solid #f4f4f4;\r\n  font-size: 16px;\r\n  line-height: 100%;\r\n  color: #b0b0b0;\r\n}\r\n.header-main .search-part input:focus{\r\n  border: 1px solid #ff6036;\r\n}\r\n.header-main .search-part input::placeholder {\r\n  color: #b0b0b0;\r\n  font-size: 16px;\r\n}\r\n.header-main .search-part .icon-search {\r\n  color: #b0b0b0;\r\n  margin-left: -35px;\r\n}\r\n.header-main .profile-part {\r\n  display: flex;\r\n  flex: 1;\r\n  gap: 15px;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n.header-main .profile-part .notification-block {\r\n  display: flex;\r\n  position: relative;\r\n}\r\n.header-main .profile-part .notification-block .noti-no {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 15px;\r\n  height: 15px;\r\n  font-size: 10px;\r\n  color: white;\r\n  border-radius: 30px;\r\n  background-color: #ff6036;\r\n  position: absolute;\r\n  top: -5px;\r\n  right: -5px;\r\n}\r\n.header-main .profile-part .profile {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n}\r\n.header-main .profile-part .profile .btn-custom {\r\n    background-color: transparent;\r\n    border: none;\r\n    color: black;\r\n    font-size: 16px;\r\n}\r\n.dropdown-item{\r\n  font-size: 14px !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* Styles for the dropdowns */\r\n.dropdowns {\r\n  position: absolute;\r\n  top: 100%; /* Position the dropdowns below the input */\r\n  /* left: 300px; */\r\n  width: 40%;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-top: none;\r\n  border-radius: 0 0 4px 4px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  /* display: none; */\r\n   /* Initially hide the dropdowns */\r\n  z-index: 1; /* Ensure it's above other content */\r\n}\r\n\r\n/* Styles for the dropdowns list */\r\n.dropdowns-list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n/* Styles for the dropdowns list items */\r\n.dropdowns-list li {\r\n  padding: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n/* Highlight list item on hover */\r\n.dropdowns-list li:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n.owl-carousel {\r\n  z-index: 0 !important;\r\n}\r\n.appointment-card, .assign-doctor-card{\r\n  z-index: 0 !important;\r\n}\r\n\r\n/* header.css */\r\n@media (max-width: 767.98px) { /* Adjust this value based on your mobile breakpoint */\r\n  .navbar-collapse.collapsing,\r\n  .navbar-collapse.show {\r\n    max-height: 100vh;\r\n    min-height: 100vh;\r\n    overflow: scroll;\r\n  }\r\n}\r\n.navbar-toggler {\r\n  border: none;\r\n  /* Optional: add a background color to the toggle button */\r\n  background-color: #f8f9fa; /* Change as needed */\r\n}\r\n@media (max-width: 767.98px) {\r\n  /* Adjust styles specifically for mobile screens here */\r\n  .navbar {\r\n    /* Any specific mobile styles */\r\n  }\r\n\r\n  .navbar-collapse {\r\n    /* Mobile specific styles */\r\n    max-height: 100vh;\r\n    min-height: 100vh;\r\n    overflow-y: auto; /* Allows scrolling within the navbar */\r\n  }\r\n\r\n  /* Adjust the padding for search input and other elements as needed */\r\n  .search-part input {\r\n    width: 100%;\r\n    margin: 0.5rem 0;\r\n  }\r\n  .search-part{\r\n    /* margin-left: 40px; */\r\n    display: none !important;\r\n  }\r\n\r\n  .profile-part{\r\n    justify-content: start !important;\r\n    margin-left: 40px;\r\n    margin-top: 2rem;\r\n    margin-bottom: 12rem !important;\r\n  }\r\n\r\n  .navbar-collapse.show .sidebar-main {\r\n    display: block;\r\n    width: 100%;\r\n    height: auto;\r\n    /* Add any additional styling for mobile sidebar here */\r\n  }\r\n\r\n}\r\n\r\n\r\n.navbar-collapse  .sidebar-main {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n/* Notification Modal Started */\r\n\r\n.notication-modal .modal-content\r\n{\r\n  padding: 0px 0px;\r\n  background-color: #F9F9F9;\r\n}\r\n\r\n.notication-modal .modal-header\r\n{\r\n  padding: 20px 30px;\r\n}\r\n.notication-modal .modal-header .modal-title{\r\n  padding-bottom: 0px;\r\n}\r\n.notication-modal .modal-body\r\n{\r\n  padding: 0px 15px;\r\n}\r\n.notication-modal .modal-dialog {\r\n  max-width: 600px;\r\n}\r\n.notication-modal .modal-content{\r\n  border-radius: 8px;\r\n}\r\n.notication-modal p {\r\n  margin-bottom: 0px;\r\n}\r\n/* Notification Modal Ended */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
